import GLightbox from 'glightbox';

let images = document.querySelectorAll('.img-zoom img');

for (let $image of images) {
    const myGallery = GLightbox({
        elements: [
            {
                'href': $image.src,
                'type': 'image',
            },
        ],
    });
    $image.addEventListener('click', () => {
        myGallery.open();
    });
}

let titles = document.querySelectorAll('h2');
let anchorTitles = [];

for (let $title of titles) {
    if ($title.id !== '') {
        anchorTitles.push($title);
    }
}

if (anchorTitles.length > 0) {
    let $contentList = document.querySelector('.content__list');
    let coordinates = [];

    $contentList.classList.add('active');

    for (let index = 0; index < anchorTitles.length; index++) {
        let $title = anchorTitles[index];

        let link = `<a href="#${$title.id}" class="content__list-item" data-anchor="${$title.id}">${$title.innerText}</a>`;

        $contentList.insertAdjacentHTML('beforeend', link);

    }

    let shift = parseInt(window.getComputedStyle(document.querySelector('.layout'), null).getPropertyValue('padding-top')) + 30;

    let items = document.querySelectorAll('.content__list-item');

    items[0].classList.add('active');

    window.addEventListener('scroll', event => {


        let activeIndex = 0;

        for (let index = 0; index < anchorTitles.length; index++) {
            let top = anchorTitles[index].getBoundingClientRect().y - shift;

            items[index].classList.remove('active');

            if (top < 0) {
                activeIndex = index;
            }
        }

        items[activeIndex].classList.add('active');

    });
}